import { Campaign } from "./campaign";
import { Participant } from "./participant";
import { MemberRole } from "./role";

export type Credits = {
  available: number,
  reserved: number,
  in_progress: number,
  consumed: number,
}

export interface Organisation {
  id: string,
  created_at: string,
  details: {
    organization_id: string,
    created_at: string,
    updated_at: string,
    name: string,
    address: string,
    city: string,
    postal_code: string,
    country: string,
    vat_id: string,
  },
  maximum_members_count: number,
}

export enum OrganisationStatType {
  ACTIVATED_PARTICIPATIONS = 'activated-participants',
  ACTIVABLE_PARTICIPATIONS = 'activable-participants',
  LAST_EVALUATED_PARTICIPATIONS = 'last-available-results',
  PARTICIPATIONS_STATE = 'participants-states',
  EVALUATED_PARTICIPATIONS_COUNT = 'evaluated-participants',
}

export type ActivatedParticipationsStats = {
  previous_month: number,
  current_month: number,
}

export type ActivableParticipationStats = {
  participant: Participant,
  campaign: Campaign,
}

export type LastEvaluatedParticipationStats = {
  participant: Participant,
  campaign: Campaign,
  calibration?: any,
}

export type EvaluatedParticipationsCountStats = {
  previous_month: number,
  current_month: number,
}

export type ParticipationsStateStats = {
  completed: number,
  in_progress: number,
  not_started: number,
}

export type OrganisationStats = ActivatedParticipationsStats | { entries: ActivableParticipationStats[] } | { entries: LastEvaluatedParticipationStats[] } | EvaluatedParticipationsCountStats | ParticipationsStateStats;

// Transaction
export type Transaction = {
  transaction_id: string;
  company_id: string,
  user_id: string,
  name: string,
  amount: number,
  amount_total: number,
  creation_time: string,
  paid_time: string,
  canceled_time: string,
}

// Members

export type OrganisationMember = {
  member_id: string,
  user: {
    user_id: string,
    candidate_id: string,
    email: string,
    first_name: string,
    last_name: string,
    phone_number: string,
    phone_verfied: boolean,
    position: any,
    image_id: string,
    creation_time: string,
  },
  role: MemberRole,
  pending_email: string,
  creation_time: string,
}

export type OrganisationInvite = {
  company_name: string,
  email: string,
  has_account: boolean,
  inviter: string,
}